import { CommonModule } from '@angular/common';
import {
	AfterViewInit,
	ChangeDetectorRef,
	CUSTOM_ELEMENTS_SCHEMA,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	Renderer2,
	ViewChild,
	ViewChildren,
} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SwiperOptions } from 'swiper/types';
import { register } from 'swiper/element/bundle';
import { BehaviorSubject, Subject, interval, takeUntil } from 'rxjs';
import OptionGroup from 'src/smoothr-web-app-core/models/OptionGroup';
import Article from 'src/smoothr-web-app-core/models/Article';
import { defaultsToArticleOption, getPrice, numberD, numberToCurrency, sleep } from 'src/smoothr-web-app-core/utils/utils';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import Order from 'src/smoothr-web-app-core/models/Order';
import { DisplayIdentifier } from 'src/smoothr-web-app-core/enums/DisplayIdentifier';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import { OrderUtils } from 'src/smoothr-web-app-core/utils/order-utils';
import { SharedModuleModule } from 'src/app/shared-module/shared-module.module';

register();
@Component({
	selector: 'app-select-half-pizza',
	standalone: true,
	imports: [CommonModule, IonicModule, TranslateModule, SharedModuleModule],
	templateUrl: './select-half-pizza.component.html',
	styleUrls: ['./select-half-pizza.component.scss'],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SelectHalfPizzaComponent implements AfterViewInit, OnInit, OnDestroy {
	private onDestroy$ = new Subject<void>();

	@ViewChild('swiperLeft', { static: false }) sliderLeft: ElementRef | undefined;
	@ViewChild('swiperRight', { static: false }) sliderRight: ElementRef | undefined;
	@ViewChild('plate', { static: false }) plate: ElementRef | undefined;

	@Input() order: Order;
	@Input() set articleGroups(value: OptionGroup[]) {
		value = value
			.filter(it => it.tags.find(tag => tag.identifier === 'half_pizza'))
			.map(it => {
				it.articles = it.articles.filter(it => it.visible && it.isActive);
				// it.articles = it.articles.length % 2 === 0 ? it.articles : it.articles.concat(it.articles[0]);
				return it;
			});
		console.log('value', value);
		this.pagesForView = value;
	}
	@Output() selectedOptionGroups = new EventEmitter<{
		left: { article: Article; optionGroup: OptionGroup };
		right: { article: Article; optionGroup: OptionGroup };
	}>();

	@Input() articleGroup: ArticleGroup;
	@Output() dismiss = new EventEmitter<void>();

	public price = 0;
	public priceText: string = '';
	pagesForView: OptionGroup[] = [];
	public activeIndex$ = new BehaviorSubject<number>(0);
	public activeIndex = 0;
	public activeTab: 'know' | 'undecided' = 'know';
	public selectedItems: Article[] = [];
	public leftSelectedItem: Article | null = null;
	public rightSelectedItem: Article | null = null;
	numberToCurrency = numberToCurrency;
	public config: SwiperOptions = {
		loop: true,
		speed: 400,
		navigation: true,
		grabCursor: true,
		autoplay: true,
		initialSlide: 1,
		effect: 'coverflow',
		direction: 'vertical',
		coverflowEffect: {
			depth: 0,
			rotate: 0,
			scale: 0.9,
			stretch: -2,
			modifier: 1.1,
		},
	};
	ngOnInit(): void {
		// console.log(this.page);
	}
	ngOnDestroy(): void {
		this.onDestroy$.next();
	}
	async ngAfterViewInit() {
		await this.sliderLeft.nativeElement?.swiper.update();
		await this.sliderRight.nativeElement?.swiper.update();
		await console.log(this.sliderLeft?.nativeElement?.swiper);

		// Initial price calculation after swiper setup
		setTimeout(() => {
			if (this.activeTab === 'undecided') {
				this.privateCalcPrice();
			}
		}, 1000);

		interval(5000)
			.pipe(takeUntil(this.onDestroy$))
			.subscribe(v => {
				if (this.activeTab === 'undecided') {
					this.privateCalcPrice();
				}
			});
		// setTimeout(() => {
		// 	this.clickRandom();
		// }, 1000);

		// await this.sliderLeft?.nativeElement.swiper.isBeginning;
		// await this.sliderRight?.nativeElement.swiper.isBeginning;

		// await this.sliderRight.nativeElement?.swiper.update();

		await sleep(200);
		const plate = this.plate.nativeElement;
		const card = document.querySelector('.slide__card');
		const cardRect = card.getBoundingClientRect();

		this.renderer.setStyle(plate, 'height', cardRect.height + 33 + 'px');
		this.renderer.setStyle(plate, 'width', cardRect.width * 2 + 33 + 'px');
	}
	constructor(private renderer: Renderer2, private cdr: ChangeDetectorRef, private translate: TranslateService) {}
	slideChange(value) {
		if (this.activeTab === 'undecided') {
			// Update price when user swipes
			this.privateCalcPrice();
		}
	}
	priceCalc(optionGroup: OptionGroup, option: Article): number {
		let price = getPrice(option, OrderType.PREORDER, this.order.preorder.type);
		if (this.fullPrice(optionGroup)) {
			price += getPrice(this.articleGroup.article, OrderType.PREORDER, this.order.preorder.type);
		}

		return price;
	}

	fullPrice(optionGroup: OptionGroup): boolean {
		return optionGroup.displayIdentifiers && optionGroup.displayIdentifiers.findIndex(di => di === DisplayIdentifier.fullPrice) >= 0;
	}
	async clickRandom() {
		const firstRandom = this.getRandom(0, this.pagesForView[0].articles.length).toFixed(0);
		const secondRandom = this.getRandom(0, this.pagesForView[0].articles.length).toFixed(0);
		await this.sliderLeft.nativeElement?.swiper.slideTo(firstRandom, 1500);
		await this.sliderRight.nativeElement?.swiper.slideTo(secondRandom, 1500);
	}
	getRandom(min: number, max: number) {
		return Math.random() * (max - min) + min;
	}
	async saveChanges() {
		if (this.activeTab === 'know') {
			// Handle "know" tab - user selected left and right items
			if (this.leftSelectedItem && this.rightSelectedItem) {
				return this.selectedOptionGroups.emit({
					left: { article: this.leftSelectedItem, optionGroup: this.pagesForView[0] },
					right: { article: this.rightSelectedItem, optionGroup: this.pagesForView[1] },
				});
			}
			return; // Don't proceed if both left and right items are not selected
		}

		// Handle "undecided" tab - existing swiper logic
		// await this.sliderLeft.nativeElement?.swiper.update;
		await this.sliderLeft.nativeElement?.swiper.update;
		await this.sliderRight.nativeElement?.swiper.update;

		const leftElement = await this.sliderLeft.nativeElement;
		const rightElement = await this.sliderRight.nativeElement;
		let activeIndexLeft = this.getElementIndex(leftElement);
		let activeIndexRight = this.getElementIndex(rightElement);
		console.log(this.pagesForView, activeIndexLeft, activeIndexRight);
		return this.selectedOptionGroups.emit({
			left: { article: this.pagesForView[0].articles[activeIndexLeft], optionGroup: this.pagesForView[0] },
			right: { article: this.pagesForView[1].articles[activeIndexRight], optionGroup: this.pagesForView[1] },
		});
	}
	private lastCalculatedIndices = { left: -1, right: -1 };

	async privateCalcPrice() {
		try {
			if (this.activeTab !== 'undecided') return;

			const leftSwiper = this.sliderLeft?.nativeElement?.swiper;
			const rightSwiper = this.sliderRight?.nativeElement?.swiper;

			if (!leftSwiper || !rightSwiper) return;

			// Use Swiper API to get real active index
			const activeIndexLeft = leftSwiper.realIndex;
			const activeIndexRight = rightSwiper.realIndex;

			// Only recalculate if indices have actually changed
			if (this.lastCalculatedIndices.left === activeIndexLeft && this.lastCalculatedIndices.right === activeIndexRight) {
				return;
			}

			this.lastCalculatedIndices = { left: activeIndexLeft, right: activeIndexRight };

			const articleLeft = this.pagesForView[0]?.articles[activeIndexLeft];
			const articleRight = this.pagesForView[1]?.articles[activeIndexRight];

			if (articleLeft && articleRight) {
				const leftPrice = getPrice(articleLeft, OrderType.PREORDER, this.order.preorder.type);
				const rightPrice = getPrice(articleRight, OrderType.PREORDER, this.order.preorder.type);
				this.price = leftPrice > rightPrice ? leftPrice : rightPrice;
			}
		} catch (e) {
			this.price = 0;
		}
	}
	getElementIndex(element: any) {
		const arrayOfSwiperElements = element.querySelectorAll('.slide');
		let activeIndex = -1;
		arrayOfSwiperElements.forEach((slide, index) => {
			if (slide.classList.contains('swiper-slide-active')) {
				const slideId = slide.getAttribute('id');
				activeIndex = slideId;
				return;
			}
		});
		return activeIndex;
	}
	backClick() {
		this.dismiss.emit();
	}
	totalPrice() {}
	onSlideChange(event: any) {
		console.log(event);
	}
	switchTab(tab: 'know' | 'undecided') {
		this.activeTab = tab;
		if (tab === 'know') {
			this.updateKnowTabPrice();
		} else {
			// For undecided tab, trigger price calculation after a short delay to ensure swipers are ready
			setTimeout(() => {
				this.privateCalcPrice();
			}, 100);
		}
	}

	get allAvailableArticles(): Article[] {
		const articles: Article[] = [];

		// Only show items from the Right side (first option group)
		if (this.pagesForView.length > 0) {
			this.pagesForView[1].articles.forEach(article => {
				if (article.visible && article.isActive) {
					articles.push(article);
				}
			});
		}

		return articles;
	}

	get leftSideArticles(): Article[] {
		const articles: Article[] = [];

		// Show items from the left side (first option group)
		if (this.pagesForView.length > 0) {
			this.pagesForView[0].articles.forEach(article => {
				if (article.visible && article.isActive) {
					articles.push(article);
				}
			});
		}

		return articles;
	}

	get rightSideArticles(): Article[] {
		const articles: Article[] = [];

		// Show items from the right side (second option group)
		if (this.pagesForView.length > 1) {
			this.pagesForView[1].articles.forEach(article => {
				if (article.visible && article.isActive) {
					articles.push(article);
				}
			});
		}

		return articles;
	}

	isSelected(article: Article): boolean {
		return this.selectedItems.some(item => item._id === article._id);
	}

	isLeftSelected(article: Article): boolean {
		return this.leftSelectedItem?._id === article._id;
	}

	isRightSelected(article: Article): boolean {
		return this.rightSelectedItem?._id === article._id;
	}

	selectLeftSide(article: Article) {
		if (this.leftSelectedItem?._id === article._id) {
			// Deselect if clicking the same item
			this.leftSelectedItem = null;
		} else {
			// Select the new item
			this.leftSelectedItem = article;
		}

		this.updateSelectedItems();
		this.updateKnowTabPrice();

		// Auto-scroll to right section after selection and DOM update
		if (this.leftSelectedItem) {
			// Trigger change detection first to ensure DOM is updated
			this.cdr.detectChanges();
			setTimeout(() => {
				this.scrollToRightSection();
			}, 300);
		}
	}

	selectRightSide(article: Article) {
		if (this.rightSelectedItem?._id === article._id) {
			// Deselect if clicking the same item
			this.rightSelectedItem = null;
		} else {
			// Select the new item
			this.rightSelectedItem = article;
		}

		this.updateSelectedItems();
		this.updateKnowTabPrice();
	}

	private updateSelectedItems() {
		this.selectedItems = [];
		if (this.leftSelectedItem) {
			this.selectedItems.push(this.leftSelectedItem);
		}
		if (this.rightSelectedItem) {
			this.selectedItems.push(this.rightSelectedItem);
		}
	}

	private scrollToRightSection() {
		setTimeout(() => {
			const rightHeader = document.getElementById('right-selection-header');
			if (rightHeader) {
				rightHeader.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
					inline: 'nearest'
				});
			} else {
				// Fallback: scroll to right selection div
				const rightSection = document.getElementById('right-selection');
				if (rightSection) {
					rightSection.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
						inline: 'nearest'
					});
				}
			}
		}, 100);
	}

	toggleSelection(article: Article) {
		const index = this.selectedItems.findIndex(item => item._id === article._id);

		if (index >= 0) {
			// Remove if already selected
			this.selectedItems.splice(index, 1);
		} else if (this.selectedItems.length < 2) {
			// Add if less than 2 items selected
			this.selectedItems.push(article);
		}

		// Update price based on selected items
		this.updateKnowTabPrice();
	}

	updateKnowTabPrice() {
		if (!this.leftSelectedItem && !this.rightSelectedItem) {
			this.price = 0;
		} else if (this.leftSelectedItem && !this.rightSelectedItem) {
			this.price = getPrice(this.leftSelectedItem, OrderType.PREORDER, this.order.preorder.type);
		} else if (!this.leftSelectedItem && this.rightSelectedItem) {
			this.price = getPrice(this.rightSelectedItem, OrderType.PREORDER, this.order.preorder.type);
		} else {
			// For both items selected, take the higher price (same logic as undecided tab)
			const leftPrice = getPrice(this.leftSelectedItem, OrderType.PREORDER, this.order.preorder.type);
			const rightPrice = getPrice(this.rightSelectedItem, OrderType.PREORDER, this.order.preorder.type);
			this.price = leftPrice > rightPrice ? leftPrice : rightPrice;
		}
	}

	getLocalizedName(article: Article): string {
		const currentLang = this.translate.currentLang || 'de';
		return article.name[currentLang] || article.name.de || '';
	}

	formatPriceWithPrefix(optionGroup: OptionGroup, article: Article): string {
		const price = this.priceCalc(optionGroup, article);
		const hasAbTag = article?.tags && article.tags.some(tag => tag.identifier === 'Ab');

		if (hasAbTag) {
			return this.translate.instant('price_prefix.from') + ' ' + this.numberToCurrency(price, this.order?.currency);
		} else {
			return this.numberToCurrency(price, this.order?.currency);
		}
	}
}
